'use client';

export default function AuthProviderButton({
  provider = 'social',
  disabled = false,
  onClick,
  label = 'Continue',
  icon = null,
}) {
  return (
    <button
      type="button"
      className="auth-provider-button-shell"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    >
      <span className={`auth-provider-button auth-provider-button--${provider}`}>
        {typeof icon === 'string' ? (
          <img
            src={icon}
            alt=""
            width="56"
            height="56"
            aria-hidden="true"
            className="auth-provider-button__icon"
          />
        ) : (
          <span className="auth-provider-button__glyph" aria-hidden="true">
            {icon}
          </span>
        )}
      </span>

      <span className="auth-provider-button__copy">{label}</span>
    </button>
  );
}